<div class="footer-wrapper">
  <div class="row m-0 p-0">
    <div class="col-12 col-md-3 mb-4 mb-sm-0">
      <div class="footer-logo">
        <img src="images/valamar-logo.svg" alt="valamar-logo" />
      </div>
    </div>
    <div class="col-12 col-md-3 mb-4 mb-sm-0">
      <div class="info-section">
        <div class="section-title">{{ 'Footer.OpenTime' | translate }}:</div>
        <div class="section-body">
          <div>{{ workingHours().opensAt }} - {{ workingHours().closingAt }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3 mb-4 mb-sm-0">
      <div class="info-section">
        <div class="section-title">{{ 'Footer.ReservationInfo' | translate }}:</div>
        <div class="section-body">
          <div><a href="tel:+385 52 407 520">+385 52 407 520</a></div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3 mb-4 mb-sm-0">
      <div class="info-section">
        <div class="section-title">{{ 'Footer.Address' | translate }}:</div>
        <div class="section-body">
          <div>Pical 1,</div>
          <div>52440 Poreč</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row m-0 p-0 social-network">
    <div class="col-12 col-md-6 col-lg-9 mb-4 mb-sm-0">
      <div class="info-section">
        <div class="info-link">
          <span class="info-link-spacing">{{
            'Footer.CookiesSettings' | translate
          }}</span>
          <span class="info-link-spacing">{{ 'Footer.PrivacyPolicy' | translate }}</span>
          <span class="info-link-spacing">{{ 'Footer.Contact' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-3 mb-4 mb-sm-0">
      <div class="social">
        <div class="platform">
          <a
            href="https://www.facebook.com/BikeCenterPorec"
            target="_blank"
            rel="noopener"
          >
            <img src="images/facebook.svg" alt="facebook" />
          </a>
        </div>
        <div class="platform">
          <a
            href="https://www.instagram.com/bikecenterporec/"
            target="_blank"
            rel="noopener"
          >
            <img src="images/instagram.svg" alt="instagram" />
          </a>
        </div>
        <div class="platform">
          <!-- <img src="images/youtube.svg" alt="youtube" /> -->
          &nbsp;
        </div>
      </div>
    </div>
  </div>
  <div class="footer-hr"></div>
  <div class="row m-0 p-0 footer-bottom-row">
    <div class="col-12 col-md-6 col-xl-5 col-xxl-4 mb-4 mb-sm-0">
      <div class="eu-logo">
        <img
          src="images/imperial-logo.png"
          width="100"
          height="64"
          alt="Imperial"
          id="imperial"
        />
        <img src="images/european-union.png" width="200" height="64" alt="EU" />
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-7 col-xxl-8 eu-description mb-6 mb-sm-0">
      {{ 'Footer.EU' | translate }}
    </div>
  </div>
</div>
